export type LogisticsReportHours = {
    regularHours: number;
    overtimeHours: number;
};

type CalculateLogisticsReportHoursArgs = {
    reportStartDate: Date;
    reportEndDate: Date;
    isBankHoliday: boolean;
    isEmployeeHoliday: boolean;
};

export function calculateLogisticsReportHours({
    reportStartDate,
    reportEndDate,
    isBankHoliday,
    isEmployeeHoliday,
}: CalculateLogisticsReportHoursArgs): LogisticsReportHours {
    if (isBankHoliday && !isEmployeeHoliday) {
        const workedHours =
            (reportEndDate.getTime() - reportStartDate.getTime()) / (1000 * 60 * 60);

        return {
            regularHours: workedHours * 2,
            overtimeHours: 0,
        };
    }

    let regularHours = 0;
    let overtimeHours = 0;
    const quarterHourInMilliseconds = 15 * 60 * 1000;
    const effectiveEndDate = reportEndDate > reportStartDate
        ? reportEndDate
        : new Date(reportEndDate.getTime() + 24 * 60 * 60 * 1000);

    for (
        let currentIntervalStart = new Date(reportStartDate);
        currentIntervalStart < effectiveEndDate;
        currentIntervalStart = new Date(currentIntervalStart.getTime() + quarterHourInMilliseconds)
    ) {
        const currentIntervalEnd = new Date(Math.min(
            currentIntervalStart.getTime() + quarterHourInMilliseconds,
            effectiveEndDate.getTime()
        ));
        const intervalHours = (currentIntervalEnd.getTime() - currentIntervalStart.getTime()) / (1000 * 60 * 60);
        const currentHour = currentIntervalStart.getHours() + currentIntervalStart.getMinutes() / 60;
        const dayOfWeek = currentIntervalStart.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

        if (isWeekend || currentHour >= 22 || currentHour < 6) {
            overtimeHours += intervalHours;
        } else {
            regularHours += intervalHours;
        }
    }

    return {regularHours, overtimeHours};
}
